var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('video',{staticClass:"videoBox",attrs:{"controls":""}},[_c('source',{attrs:{"src":_vm.url}})])])}
var staticRenderFns = []

export { render, staticRenderFns }